/* eslint-disable react/no-multi-comp, react/display-name */

import React from 'react';
import {Route, Switch} from 'react-router-dom';

import {MainLayout} from './layouts/mainLayout/MainLayout';
import {SimpleLayout} from './layouts/simpleLayout/SimpleLayout';
import {VideoPageLayout} from './layouts/videoPageLayout/VideoPageLayout';

// import AppPage from './pages/app/AppPage';
// import BenefitsPage from './pages/benefits/BenefitsPage';
import RegisterPage from './pages/contact/ContactPage';
import EightOneOnePage from './pages/eightOneOne/EightOneOnePage';
import EooDamageReportingPage from './pages/eooDamageReporting/EooDamageReportingPage';
// import FactsAndStatsPage from './pages/factsAndStats/FactsAndStatsPage';
import GoalsPage from './pages/goals/GoalsPage';
import HomePage from './pages/home/HomePage';
import LawPage from './pages/law/LawPage';
import LeakRecognitionPage from './pages/leakRecognition/LeakRecognitionPage';
import MarkersPage from './pages/markers/MarkersPage';
import NotFound from './pages/404/NotFound';
import PreventionMeasuresPage from './pages/preventionMeasures/PreventionMeasuresPage';
import PrivacyPolicyPage from './pages/privacyPolicy/privacyPolicy';
import ResourcesPage from './pages/resources/ResourcesPage';
import ResponsePage from './pages/response/ResponsePage';
import safetyPage from './pages/safeDiggingChecklist/safeDiggingChecklist.js';
// import SponsorshipOptionsPage from './pages/sponsorshipOptions/SponsorshipOptionsPage';
import StateChecklistPage from './pages/stateChecklist/StateChecklistPage';
import StateLawPage from './pages/stateLaw/StateLawPage';
import StateLocateRequestPage from './pages/stateLocateRequest/StateLocateRequestPage';
import StateResourcePage from './pages/stateResource/StateResourcePage';
import StateResourcesPage from './pages/stateResources/StateResourcesPage';

import StatePage from './pages/state/StatePage';
import StatesPage from './pages/states/StatesPage';
import SupportingCompaniesPage from './pages/supportingCompanies/SupportingCompaniesPage';
import termsAndConditions from './pages/termsAndConditions/termsAndConditions';
import UgiCommunicationsPage from './pages/ugiCommunications/UgiCommunicationsPage';
import UgiElectricityPage from './pages/ugiElectricity/UgiElectricityPage';
import UgiPipelinesPage from './pages/ugiPipelines/UgiPipelinesPage';
import UgiWaterSewerPage from './pages/ugiWaterSewer/UgiWaterSewerPage';
import UndergroundInfrastructure from './pages/undergroundInfrastructure/UndergroundInfrastructurePage';
// import Video811Page from './pages/video811/Video811Page';
// import VideoTeaserPage from './pages/videoTeaser/VideoTeaserPage';

import VideoPage from './pages/videoPages/videoPages';
import * as routePaths from './routePaths';
import ScrollToTop from './common/scrollToTop/ScrollToTop';


import {SECTION_NEI, SECTION_UNDERGROUND_INFRASTRUCTURE, SECTION_811} from './constants';



/**
 * Builds a page using the main layout.
 *
 * @param {{}} PageComponent
 * @param {string} pageTitle
 * @returns {{}}
 */
function largeHeaderLayout(PageComponent, pageTitle) {
  return (props) => (
    <ScrollToTop scrollTo={scrollTo}>
      <MainLayout largeHeader page={<PageComponent {...props} />} pageTitle={pageTitle} {...props} />
    </ScrollToTop>
  );
}

function videoPageLayoutFunc(PageComponent) {
  return (props) =>(
    <VideoPageLayout page={<PageComponent {...props} />}  {...props} />
  );
}

/**
 * Builds a page using the main layout.
 *
 * @param {{}} PageComponent
 * @param {string} pageTitle
 * @returns {{}}
 */
function layoutPage(PageComponent, pageTitle, section, scrollTo) {
  return (props) => (
    <ScrollToTop scrollTo={scrollTo}>
      <MainLayout page={<PageComponent {...props} />} pageTitle={pageTitle} section={section} {...props} />
    </ScrollToTop>
  );
}

function layoutPageWithVideo(PageComponent, pageTitle, section) {
  return (props) => (
    <ScrollToTop scrollTo={scrollTo}>
      <MainLayout hasVideo page={<PageComponent {...props} />} pageTitle={pageTitle} section={section} {...props} />
    </ScrollToTop>
  );
}

/**
 * Builds a page using the simple layout.
 *
 * @param {{}} PageComponent
 * @param {string} pageTitle
 * @returns {{}}
 */
function simplePage(PageComponent, pageTitle) {
  return (props) => (<SimpleLayout page={<PageComponent {...props} />} pageTitle={pageTitle} {...props} />);
}

/**
 * Builds the routes for the app.
 * @returns {*}
 */

export function buildRoutes() {
  // we're gonna use the existing header component until the sunday deadline,
  // and we don't wanna change the component hierarchy either, so just pass in all the
  // header stuff here - hayden :)

  const orange = '#e65016';
  const white = 'white';
  const ugiWaterSewerTitle = (<span><span style={{color: orange}}>Water and Sewer </span><span style={{color: white}}>Systems</span></span>);
  const goalsTitle = (<span><span style={{color: white}}>Our </span><span style={{color: orange}}>Goal</span></span>);
  const supportingCompaniesTitle = (<span><span style={{color: white}}>Supporting </span><span style={{color: orange}}>Companies and Partners</span></span>);
  const ugiElectricTitle = (<span><span style={{color: orange}}>Powering </span><span style={{color: white}}>the Electric Grid</span></span>);
  const ugiCommunicationsTitle = (<span><span style={{color: orange}}>Voice, Video, &amp; Data </span><span style={{color: white}}>Cables</span></span>);
  const eooDamageReportingTitle = (<span><span style={{color: white}}>Report Any </span><span style={{color: orange}}>Pipeline Damage</span></span>);
  const responseTitle = (<span><span style={{color: white}}>Actions to </span><span style={{color: orange}}>Take or Avoid</span></span>);
  const preventionMeasuresTitle = (<span><span style={{color: orange}}>Safe and Reliable </span><span style={{color: white}}>through Design and Hard Work</span></span>);
  const termsAndConditionsTitle = (<span><span style={{color: white}}> Terms </span><span style={{color: orange}}> And </span><span style={{color: white}}>Conditions</span></span>);
  const privacyPolicyTitle = (<span><span style={{color: orange}}>Privacy </span><span style={{color: white}}>Policy</span></span>);

  const leakRecognitionTitle = (<span><span style={{color: white}}>Use your </span><span style={{color: orange}}>Senses</span></span>);
  const safeDiggingTitle = (<span><span style={{color: orange}}>Safe Digging </span><span style={{color: white}}>Checklist</span></span>);
  const markersTitle = (<span><span style={{color: orange}}>Spot </span><span style={{color: white}}>the Sign</span></span>);
  const undergroundInfrastructureTitle = (<span><span style={{color: orange}}>Underground Infrastructure </span><span style={{color: white}}>Making the Modern World Possible</span></span>);
  const registerTitle = (<span><span style={{color: orange}}>Contribute</span></span>);
  const resourcesTitle = (<span><span style={{color: orange}}>Resources</span></span>);
  const pipelinesTitle = (<span><span style={{color: orange}}>Energy </span><span style={{color: white}}>Pipelines</span></span>);
  const statesTitle = (<span><span style={{color: orange}}>Dig Deeper into </span><span style={{color: white}}>What is Required in your State</span></span>);

  return (
    <Switch>

      {/*<Route path={routePaths.appRoute} render={layoutPage(AppPage)} />*/}
      {/*<Route path={routePaths.benefitsRoute} render={layoutPage(BenefitsPage)} />*/}
      <Route path={routePaths.eightOneOneRoute} render={layoutPageWithVideo(EightOneOnePage,'',SECTION_811)} />
      <Route path={routePaths.registerRoute} render={layoutPage(RegisterPage, registerTitle, SECTION_NEI)} />
      <Route path={routePaths.eooDamageReportingRoute} render={layoutPage(EooDamageReportingPage, eooDamageReportingTitle, SECTION_UNDERGROUND_INFRASTRUCTURE)} />
      {/*<Route path={routePaths.factsAndStatsRoute} render={layoutPage(FactsAndStatsPage)} />*/}
      <Route path={routePaths.goalsRoute} render={layoutPage(GoalsPage, goalsTitle, SECTION_NEI)} />
      <Route path={routePaths.leakRecognitionRoute} render={layoutPage(LeakRecognitionPage, leakRecognitionTitle, SECTION_UNDERGROUND_INFRASTRUCTURE)} />
      <Route path={routePaths.markersRoute} render={layoutPage(MarkersPage, markersTitle, SECTION_UNDERGROUND_INFRASTRUCTURE)} />
      <Route path={routePaths.preventionMeasuresRoute} render={layoutPage(PreventionMeasuresPage, preventionMeasuresTitle, SECTION_UNDERGROUND_INFRASTRUCTURE)} />
      <Route path={routePaths.privacyPolicy} render={layoutPage(PrivacyPolicyPage, privacyPolicyTitle, SECTION_NEI)} />
      <Route path={routePaths.resourcesRoute} render={layoutPage(ResourcesPage, resourcesTitle, SECTION_UNDERGROUND_INFRASTRUCTURE)} />
      <Route path={routePaths.responseRoute} render={layoutPage(ResponsePage, responseTitle, SECTION_UNDERGROUND_INFRASTRUCTURE)} />
      {/*<Route path={routePaths.sponsorshipOptionsRoute} render={layoutPage(SponsorshipOptionsPage)} />*/}

      <Route path={routePaths.lawRoute} render={layoutPage(LawPage, statesTitle, SECTION_811, [0, 675])} />
      <Route path={routePaths.stateChecklistRoute} render={layoutPage(StateChecklistPage, statesTitle, SECTION_811, [0, 675])} />
      <Route path={routePaths.stateLawRoute} render={layoutPage(StateLawPage, statesTitle, SECTION_811, [0, 675])} />
      <Route path={routePaths.stateLocateRequestRoute} render={layoutPage(StateLocateRequestPage, statesTitle, SECTION_811, [0, 675])} />
      <Route path={routePaths.stateResourceRoute} render={layoutPage(StateResourcePage, statesTitle, SECTION_811, [0, 675])} />
      <Route path={routePaths.stateResourcesRoute} render={layoutPage(StateResourcesPage, statesTitle, SECTION_811, [0, 675])} />

      <Route path={routePaths.stateRoute} render={layoutPage(StatePage, statesTitle, SECTION_811, [0, 675])} />
      <Route path={routePaths.statesRoute} render={layoutPage(StatesPage, statesTitle, SECTION_811, [0, 675])} />


      <Route path={routePaths.supportingCompaniesRoute} render={layoutPage(SupportingCompaniesPage, supportingCompaniesTitle, SECTION_NEI)} />
      <Route path={routePaths.termsAndConditions} render={layoutPage(termsAndConditions, termsAndConditionsTitle, SECTION_NEI)} />
      <Route path={routePaths.ugiCommunicationsRoute} render={layoutPage(UgiCommunicationsPage, ugiCommunicationsTitle, SECTION_UNDERGROUND_INFRASTRUCTURE)} />
      <Route path={routePaths.ugiElectricityRoute} render={layoutPage(UgiElectricityPage, ugiElectricTitle, SECTION_UNDERGROUND_INFRASTRUCTURE)} />
      <Route path={routePaths.ugiPipelinesRoute} render={layoutPage(UgiPipelinesPage,pipelinesTitle,SECTION_UNDERGROUND_INFRASTRUCTURE)} />
      <Route path={routePaths.ugiWaterSewerRoute} render={layoutPage(UgiWaterSewerPage, ugiWaterSewerTitle, SECTION_UNDERGROUND_INFRASTRUCTURE)} />
      <Route path={routePaths.undergroundInfrastructureRoute} render={layoutPage(UndergroundInfrastructure, undergroundInfrastructureTitle, SECTION_UNDERGROUND_INFRASTRUCTURE)} />
      {/*<Route path={routePaths.video811} render={layoutPage(Video811Page)} />*/}
      {/*<Route path={routePaths.videoTeaser} render={layoutPage(VideoTeaserPage)} />*/}
      <Route path={routePaths.safeDigging} render={layoutPage(safetyPage, safeDiggingTitle, SECTION_811)} />
      <Route exact path={routePaths.homeRoute} render={largeHeaderLayout(HomePage)} />
      <Route path={routePaths.videoPageRoute} component={videoPageLayoutFunc(VideoPage)} />
    </Switch>
  );
}

export default buildRoutes;



// WEBPACK FOOTER //
// ./src/components/routes.js